import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { countryOptions as unsortedCountryOptions } from '../../../models/statecountryoptions';
import { stateOptions as unsortedStateOptions } from '../../../models/statecountryoptions';

import { DialogComponent } from '../../../shared/components/dialog/dialog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { SubmissionService } from '../../../services/submission/submissionsuccess.service';
import {
  contactNumberValidator,
  emailValidator,
  latinAlphabetValidator,
  variableLengthValidator,
  postCodeValidator
} from '../../../shared/Validators/custom-validators';
import { sstRegistrationNumberValidator } from '../../../shared/Validators/receipt-details-validators';
import { BuyertinService } from '../../../services/buyertin/buyertin.service';

@Component({
  selector: 'app-buyer-details',
  templateUrl: './buyer-details.component.html',
  styleUrls: ['./buyer-details.component.scss'],
  standalone: false
})
export class BuyerDetailsComponent implements OnInit {
  private readonly isFormSubmittedState = signal(false);
  private readonly buyerEmailState = signal('');
  private readonly isEmailValidatedState = signal(false);
  private readonly isOtpRequestedState = signal(false);
  private readonly isOtpConfirmedState = signal(false);
  private readonly otpTimerState = signal(120);
  private readonly isResendDisabledState = signal(true);
  private readonly combinedDataState = signal<any>({});

  get isFormSubmitted() { return this.isFormSubmittedState(); }
  set isFormSubmitted(value: boolean) { this.isFormSubmittedState.set(value); }
  get buyerEmail() { return this.buyerEmailState(); }
  set buyerEmail(value: string) { this.buyerEmailState.set(value); }
  get isEmailValidated() { return this.isEmailValidatedState(); }
  set isEmailValidated(value: boolean) { this.isEmailValidatedState.set(value); }
  get isOtpRequested() { return this.isOtpRequestedState(); }
  set isOtpRequested(value: boolean) { this.isOtpRequestedState.set(value); }
  get isOtpConfirmed() { return this.isOtpConfirmedState(); }
  set isOtpConfirmed(value: boolean) { this.isOtpConfirmedState.set(value); }
  get otpTimer() { return this.otpTimerState(); }
  set otpTimer(value: number) { this.otpTimerState.set(value); }
  get isResendDisabled() { return this.isResendDisabledState(); }
  set isResendDisabled(value: boolean) { this.isResendDisabledState.set(value); }
  get combinedData() { return this.combinedDataState(); }
  set combinedData(value: any) { this.combinedDataState.set(value); }

  @Input() receiptDetails: any;
  @Output() formSubmitted = new EventEmitter<void>();
  buyerDetailsForm!: FormGroup;
  stateOptions: { name: string; value: string }[] = [];
  countryOptions: { name: string; value: string; disabled?: boolean }[] = [];
  originalCountryOptions: { name: string; value: string }[] = [];
  dialogRef: DynamicDialogRef | null = null;
  timerInterval: any;

  formData: any = {
    receiptDetails: null,
    buyerTIN: null,
    buyerDetails: null,
  };
  private otpTimeout: any;
  constructor(
    private fb: FormBuilder,
    private dialogService: DialogService,
    private router: Router,
    private submissionService: SubmissionService,
    private buyerTinService: BuyertinService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    console.log('Received receipt details:', this.receiptDetails);
    this.createForm();
    this.buyerDetailsForm.get('country')?.valueChanges.subscribe(() => {
    this.buyerDetailsForm.get('postCode')?.updateValueAndValidity();
    });
    this.stateOptions = unsortedStateOptions
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name));
    // Prepare and sort country options
    this.originalCountryOptions = unsortedCountryOptions
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name));

    // Clone original options for initial load
    this.countryOptions = [...this.originalCountryOptions];

    // Watch for state changes
    this.onStateChange();
    const countryNames = this.countryOptions.map((country) => country.name);
    console.log(countryNames);
    console.log(this.stateOptions.length);
    console.log(this.countryOptions.length);
  }
  createForm() {
    this.buyerDetailsForm = this.fb.group({
      buyerLegalName: ['', [Validators.required, variableLengthValidator(300),latinAlphabetValidator]],
      sstRegNumber: [
        '',
        [
          Validators.required,
          variableLengthValidator(35),
          sstRegistrationNumberValidator,
        ],
      ],
      contactNumber: ['', [Validators.required, variableLengthValidator(20),contactNumberValidator]],
      email: ['', [Validators.required, emailValidator]],
      addressLine1: ['', [Validators.required, variableLengthValidator(150)]],
      addressLine2: ['', [variableLengthValidator(150)]],
      addressLine3: ['', [variableLengthValidator(150)]],
      postCode: ['',[postCodeValidator(() => this.buyerDetailsForm?.get('country')?.value, 50),],
    ],
      city: ['', [Validators.required, variableLengthValidator(50)]],
      state: ['', [Validators.required]],
      country: ['', [Validators.required]],
      otp: ['', ],
    });
  }
  get f() {
    return this.buyerDetailsForm.controls;
  }
  getFormData() {
    return this.buyerDetailsForm.getRawValue();
  }
  // Monitor changes in the state field
  onStateChange() {
    console.log('calling state change ');
    this.buyerDetailsForm.get('state')?.valueChanges.subscribe((stateValue) => {
      console.log(stateValue);
      if (stateValue !== 'Not Applicable') {
        this.disableAllCountriesExceptMalaysia();
      } else {
        this.resetCountryOptions();
      }
    });
  }
  onEmailInput() {
    const emailValue = this.buyerDetailsForm.get('email')?.value;
    console.log(emailValue, emailValue.length);
    if (emailValue && emailValue.length > 320) {
      console.log('Email cannot be more than 320 characters.');
    } else {
    }
  }
  // Disable all countries except Malaysia
  disableAllCountriesExceptMalaysia() {
    this.countryOptions = this.originalCountryOptions.map((option) => ({
      ...option,
      disabled: option.name !== 'Malaysia',
    }));
    this.buyerDetailsForm.get('country')?.setValue('Malaysia');
  }

  onValidateEmail(): void {
    if (this.f['email'].valid) {
      this.isEmailValidated = true;
      this.requestOtp();
    }
  }

  requestOtp(): void {
    // this.formData.receiptDetails=this.receiptDetailsComponent.getFormData();

    const sellerBrn= this.receiptDetails.sellerBRN;
    const buyerEmailId=this.f['email'].value
    console.log(sellerBrn)
    console.log(buyerEmailId)
    this.buyerTinService.triggerOTP(sellerBrn,buyerEmailId).subscribe((resp)=>{
    if(resp){
      console.log(resp)
      if(resp.triggerOTPResp=='OTPTriggerSuccess'){
        this.isOtpRequested = true;
        this.isResendDisabled = true;
        this.startOtpTimer();
        this.changeDetectorRef.detectChanges();
    
        // Simulate OTP request here (e.g., send OTP via email)
        console.log('OTP has been sent to:', this.f['email'].value);
      }
      if(resp.triggerOTPResp=='OTPTriggerFailed'){
        this.isEmailValidated = false;
        this.openErrorDialogue('OTP Sent Failed, Please try again.');
        this.changeDetectorRef.detectChanges();
        // Simulate OTP request here (e.g., send OTP via email)
        console.log('OTP has been sent to:', this.f['email'].value);
      }
    }
    },(err)=>{
      console.log('Error',err)
    })
  
  }

  startOtpTimer(): void {
    this.otpTimer = 120;
    this.timerInterval = setInterval(() => {
      this.otpTimer--;
      if (this.otpTimer === 0) {
        clearInterval(this.timerInterval);
        this.isResendDisabled = false;
      }
      this.changeDetectorRef.detectChanges();
    }, 1000);
  }

  onResendOtp(): void {
    this.requestOtp();
  }

  onConfirmOtp(): void {
    const otpValue = this.f['otp'].value;
    const buyerEmailId=this.f['email'].value
    if (/^\d{6}$/.test(otpValue)) {
      this.buyerTinService.validateOTP(otpValue,buyerEmailId).subscribe((resp)=>{
        if(resp){
          if(resp.validateOtpResp=='OTPValidationSuccess'){
            this.isOtpConfirmed = true;
            console.log('OTP confirmed successfully');
            if (this.isEmailValidated && this.isOtpConfirmed) {
              this.buyerDetailsForm.get('email')?.disable(); 
            }
            this.changeDetectorRef.detectChanges();
          }
          if(resp.validateOtpResp=='OTPValidationFailed'){
            this.isOtpConfirmed = false;
            this.openErrorDialogue(' The OTP is incorrect.');
            this.changeDetectorRef.detectChanges();
           
          }
        }
      })
    
    } else {
      this.isOtpConfirmed = false;
      this.openErrorDialogue('Please provide valid OTP.');
    }
  }
  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.charCode || event.keyCode;
  
    // Allow only numeric keys (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  removeNonNumeric(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');
    this.buyerDetailsForm.get('otp')?.setValue(inputElement.value); // Update the form control value
  }
  onResetEmail() {
    this.openresetconfirmation();
  }
  openresetconfirmation() {
    this.dialogRef = this.dialogService.open(DialogComponent, {
      header: 'Confirmation',
      width: '600px',
      data: {
        title: '',
        messages: [
          'This validated email address would be reset and you will need to validate a new e-mail address again. Do you wish to continue?',
        ],
        confirm: true,
      },
      contentStyle: { 'max-height': '700px', overflow: 'auto' },
    });
    this.dialogRef?.onClose.subscribe((response) => {
      console.log(response);
      if (response) {
        console.log('res', response);
        if (response == true) {
          this.buyerDetailsForm.patchValue({
            email: '',
            otp:'' 
          });
          const control = this.buyerDetailsForm.get('email');
          if (control) {
            control.enable();
            control.markAsPristine();
            control.markAsUntouched();
          }
          // this.buyerDetailsForm.get('email')?.markAsTouched();
          this.isEmailValidated = false;
          this.isOtpRequested = false;
          this.isOtpConfirmed = false;
         
          this.stopOtpTimer();
        } else {
          this.isFormSubmitted = false;
        }
      }
    });
  }
  stopOtpTimer() {
    clearInterval(this.timerInterval);
    this.isResendDisabled = false;
  }
  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
  // Reset the country options to their original state
  resetCountryOptions() {
    this.countryOptions = this.originalCountryOptions.map((option) => ({
      ...option,
      disabled: false,
    }));
    this.buyerDetailsForm.get('country')?.reset();
  }
  confirmAndSubmit(data: any) {
    this.combinedData = data;
    console.log('recevied form data', this.combinedData);
    this.openconfirmation();
  }

  hasInvalidMalaysiaStateSelection(): boolean {
    return (
      this.buyerDetailsForm.get('country')?.value === 'Malaysia' &&
      this.buyerDetailsForm.get('state')?.value === 'Not Applicable'
    );
  }

onSubmit(): void {
  if (!this.buyerDetailsForm.valid) {
    console.log('Please fill all required fields.');
    return;
  }

  if (this.hasInvalidMalaysiaStateSelection()) {
    this.openErrorDialogue('Select a valid state Code');
    return;
  }

  if (this.isOtpConfirmed) {
    this.formSubmitted.emit();
  } else {
    this.openErrorDialogue(
      'Please validate the e-mail address before submitting the E-invoice request.'
    );
  }
}
  openconfirmation() {
    this.dialogRef = this.dialogService.open(DialogComponent, {
      header: 'Confirmation',
      width: '600px',
      data: {
        title: '',
        messages: [
          'I have completed e-Invoice data as required by tax authority, acknowledge accuracy of the data, and confirm submission of my e-invoice data to the tax authority via this request.',
        ],
        confirm: true,
      },
      contentStyle: { 'max-height': '700px', overflow: 'auto' },
    });
    this.dialogRef?.onClose.subscribe((response) => {
      console.log(response);
      if (response) {
        console.log('res', response);
        if (response == true) {
          this.submitToGTESPortal();
        } else {
          this.isFormSubmitted = false;
        }
      }
    });
  }

  submitToGTESPortal() {
    console.log('Submitting Combined Data:', this.combinedData);
    this.buyerEmail = this.combinedData.buyerDetails.email;
    this.buyerTinService.submitreciept(this.combinedData).subscribe(
      (response: any) => {
          if (response.emailResponses && response.emailResponses.length > 0) {
             const firstResponse = response.emailResponses[0];

             const status = firstResponse.status;
             const message = firstResponse.message;
             const responseStatus = status || '';
             console.log('responseStatus', responseStatus);

             if (responseStatus == 'Valid') {
                console.log('success', responseStatus);
                const maskMailId = firstResponse.maskedEmailId ? firstResponse.maskedEmailId : this.buyerEmail;
                this.submissionService.setBuyerEmail(maskMailId);
                this.showSuccessPage();
             }
             if (responseStatus == 'Invalid') {
                console.log('success', responseStatus);
                this.openErrorDialogue(message);
             } else {
               // else popup open
               console.log('Error');
             }
          } else if (response.status && response.status == 'Invalid') {
              this.openErrorDialogue(response.message);
          }
        },
         (error) => {
         this.openErrorDialogue(error);
        }
      );
    // setTimeout(() => {
    //   const validationSuccess = true;
    //   if (validationSuccess) {
    //     this.submissionService.setBuyerEmail(this.buyerEmail);
    //     this.showSuccessPage();
    //   } else {
    //     console.log('Validation failed');
    //   }
    // }, 500);
  }

  showSuccessPage() {
    this.isFormSubmitted = true;
    this.disableFormFields();
    this.submissionService.setFormSubmitted(true);
    this.router.navigateByUrl('/submission-success');
  }
  disableFormFields() {
    Object.keys(this.buyerDetailsForm.controls).forEach((key) => {
      this.buyerDetailsForm.get(key)?.disable();
    });
  }
  resetForm() {
    this.buyerDetailsForm.reset();
    this.isFormSubmitted = false;
    Object.keys(this.buyerDetailsForm.controls).forEach((key) => {
      const control = this.buyerDetailsForm.get(key);
      if (control) {
        control.enable();
        control.markAsPristine();
        control.markAsUntouched();
      }
    });
  }

  openErrorDialogue(message: string) {
    this.dialogRef = this.dialogService.open(DialogComponent, {
      header: 'Error',
      width: '600px',
      data: {
        title: '',
        messages: [message],
      },
      contentStyle: { 'max-height': '700px', overflow: 'auto' },
    });
  }
}
